module.exports = __webpack_public_path__ + "static/img/ios_code.5fc6a08f.png";